"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBTextField;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _HelpOutline = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Help-outline.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
* Global components
* By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
* Summary
* This component renders a SVB text field
*/

/**
* SVBTextField
* @param {function} [handleOnMouseOver] - Function to be excecuted when hovering on the help icon
* @param {function} [handleOnMouseOut] - Function to be excecuted when unhovering on the help icon
* @param {function} [handleButtonClick] - Function to be excecuted when clicking the button
* @param {boolean} [isDisabled = false] - Boolean that determines if the field is disabled or not
* @param {string} [buttonText] - Text to be displayed in the inner button
* @param {boolean} [hasHelpIcon = false] - Boolean that determines if the field has a help icon
* @param {string} [label] - Text to be displayed in the field label
* @param {boolean} [isError = false] - Boolean that determines if the field is an error or not
* @param {number} [maxCharacterCount] - Maximun number of characters allowed for the field
* @param {string} [helpText] - Help text to be displayed
* @param {number} [inputWidth = 3] - Width of the field (in bootstrap numbers 1 to 12)
* @param {function} handleOnChange - Function to be excecuted on input change
* @param {string} name - Name of the input
* @param {(string|number)} value - Value of the input
* @param {string} [placeholder] - Text to be displayed as the field placeholder
* @param {string} id - Id for the input
* @param {string} type - Type of the input
* @param {string} [extraClasses = ""] - Extra classes to be added to the text field wrapper
* @returns JSX element
*/
function SVBTextField(props) {
  (0, _react.useLayoutEffect)(() => {
    const event = new CustomEvent("SVBApplyStylesBehavior", {
      detail: "input-label"
    });
    document.dispatchEvent(event);
  }, []);

  // Prop error handling
  let componentError = false;
  const typeCheck = function typeCheck(prop, types) {
    let extraValidations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!types.includes(typeof prop)) componentError = true;
    if (extraValidations && typeof prop !== "undefined") {
      for (let validation of extraValidations) {
        if (!validation(prop)) componentError = true;
      }
    }
    return prop;
  };
  const isBootstrapWidth = width => !(width > 12 || width < 1 || !Number.isInteger(width));
  const handleOnMouseOver = typeCheck(props.handleOnMouseOver, ["function", "undefined"]);
  const handleOnMouseOut = typeCheck(props.handleOnMouseOut, ["function", "undefined"]);
  const handleButtonClick = typeCheck(props.handleButtonClick, ["function", "undefined"]);
  const isDisabled = typeCheck(props.isDisabled, ["boolean", "undefined"]) || false;
  const buttonText = typeCheck(props.buttonText, ["string", "undefined"]);
  const hasHelpIcon = typeCheck(props.hasHelpIcon, ["boolean", "undefined"]) || false;
  const hasIconOrButton = [buttonText, hasHelpIcon].some(element => element);
  const label = typeCheck(props.label, ["string", "undefined"]);
  const isError = typeCheck(props.isError, ["boolean", "undefined"]) || false;
  const maxCharacterCount = typeCheck(props.maxCharacterCount, ["number", "undefined"]) && parseInt(props.maxCharacterCount);
  const helpText = typeCheck(props.helpText, ["string", "undefined"]);
  const hasTextBelow = [maxCharacterCount, helpText].some(element => element);
  const inputWidth = typeCheck(props.inputWidth, ["number", "undefined"], [isBootstrapWidth]) || 3;
  const handleOnChange = typeCheck(props.handleOnChange, ["function"]);
  const name = typeCheck(props.name, ["string"]);
  const value = typeCheck(props.value, ["string", "number"]);
  const placeholder = typeCheck(props.placeholder, ["string", "undefined"]);
  const id = typeCheck(props.id, ["string"]);
  const type = typeCheck(props.type, ["string", "undefined"], [value => ["text", "email", "number", "password"].includes(value)]) || "text";
  const extraClasses = typeCheck(props.extraClasses, ["string", "undefined"]) || "";

  // Prop error check
  if (componentError) return /*#__PURE__*/_react.default.createElement("p", null, "Invalid prop sent, check console for prop type errors.");
  const getMarginBottom = indicator => indicator ? "" : "mb-3";
  const getInputErrorClass = indicator => indicator ? "input-error" : "";
  const getInputHelpClass = indicator => indicator ? "input-help" : "";
  const getInputLabelClass = indicator => indicator ? "" : "input-no-label";
  const getInputIconButtonClass = indicator => indicator ? "input-button-icon" : "";
  const getLabelErrorClass = indicator => indicator ? "label-error" : "";
  const getLabelDisabledClass = indicator => indicator ? "label-disabled" : "";
  const getHelpErrorClass = indicator => indicator ? "input-help-text-error" : "";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: extraClasses
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "".concat(getInputIconButtonClass(hasIconOrButton), " ").concat(getInputLabelClass(label), " ").concat(getInputHelpClass(hasTextBelow), " ").concat(getInputErrorClass(isError), " ").concat(getMarginBottom(hasTextBelow), " col-").concat(inputWidth),
    onChange: handleOnChange,
    name: name,
    type: type,
    id: id,
    placeholder: placeholder,
    value: value,
    disabled: isDisabled,
    maxLength: maxCharacterCount
  }), label && /*#__PURE__*/_react.default.createElement("label", {
    className: "input-type_label ".concat(getLabelDisabledClass(isDisabled), " ").concat(getLabelErrorClass(isError)),
    htmlFor: id
  }, label), helpText && /*#__PURE__*/_react.default.createElement("p", {
    className: "input-help-text input-help-text_info ".concat(getHelpErrorClass(isError))
  }, helpText), maxCharacterCount && /*#__PURE__*/_react.default.createElement("p", {
    className: "input-help-text input-help-text_character-count ".concat(getHelpErrorClass(isError))
  }, "".concat(value.length.toString().padStart(maxCharacterCount.toString().length, "0"), "/").concat(maxCharacterCount)), hasHelpIcon && /*#__PURE__*/_react.default.createElement("img", {
    onMouseOver: handleOnMouseOver,
    onMouseOut: handleOnMouseOut,
    className: "input-inner-icon",
    src: _HelpOutline.default,
    alt: "help"
  }), buttonText && /*#__PURE__*/_react.default.createElement("button", {
    onClick: handleButtonClick,
    className: "input-inner-button",
    type: "submit"
  }, buttonText));
}
;
SVBTextField.propTypes = {
  handleOnMouseOver: _propTypes.default.func,
  handleOnMouseOut: _propTypes.default.func,
  handleButtonClick: _propTypes.default.func,
  isDisabled: _propTypes.default.bool,
  buttonText: _propTypes.default.string,
  hasHelpIcon: _propTypes.default.bool,
  label: _propTypes.default.string,
  isError: _propTypes.default.bool,
  maxCharacterCount: _propTypes.default.number,
  helpText: _propTypes.default.string,
  inputWidth: function inputWidth(props, propName) {
    if (typeof props[propName] !== "undefined") {
      if (typeof props[propName] !== "number" || props[propName] < 1 || props[propName] > 12 || !Number.isInteger(props[propName])) {
        return new Error("Invalid ".concat(propName, " prop - ").concat(propName, " prop must be an integer between 1 and 12"));
      }
    }
  },
  handleOnChange: _propTypes.default.func.isRequired,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  placeholder: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  type: _propTypes.default.oneOf(["text", "email", "number", "password"]),
  extraClasses: _propTypes.default.string
};